export default __webpack_public_path__ + "static/media/57.332cdbe4.png";